import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import { DataServiceService } from 'src/app/services/data-service.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ChartPackage } from 'src/app/models/chart';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ChartEmbedComponent } from '../_components/chart-embed/chart-embed.component';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-charts',
    templateUrl: './charts.component.html',
    styleUrls: ['./charts.component.scss'],
    imports: [ChartEmbedComponent,RouterModule,CommonModule,FontAwesomeModule]
})
export class ChartsComponent {
  faLink = faLink;
  chartId = 250; 
  constructor(private service: DataServiceService) {}
  updateChart(id) {
    this.chartId = id;
  }
}
